import { HeroSplashAppDemo } from "@/components/marketing/HeroSplashAppDemo"
import { MinimalMarketingLayout } from "@/components/marketing/MinimalMarketingLayout"
import { ButtonLink } from "@/components/marketing/elements/button"
import { AnnouncementBadge } from "@/components/marketing/elements/announcement-badge"
import { Section } from "@/components/marketing/elements/section"
import { MarketingScenarioModelSection } from "@/components/marketing/sections/MarketingScenarioModelSection"
import { HeroWithDemoOnBackground } from "@/components/marketing/sections/hero-with-demo-on-background"
import { PRODUCT_TAGLINE } from "@/content/marketing/site-content"
import { primaryCtaHref, primaryCtaLabel } from "@/lib/launch-config"

export function ComingSoonLandingPage() {
  return (
    <MinimalMarketingLayout>
      <HeroWithDemoOnBackground
        id="hero"
        eyebrow={
          <AnnouncementBadge text="Coming soon" variant="overlay" />
        }
        headline={PRODUCT_TAGLINE}
        subheadline={
          <p>
            ArtlessDev is in private preview. Request early access to write down, once, exactly what your
            software does — plainly enough for a stakeholder to read, and precisely enough for a developer, a
            QA engineer, or an AI agent to check against reality.
          </p>
        }
        cta={
          <ButtonLink href={primaryCtaHref()} size="lg" color="light">
            {primaryCtaLabel()}
          </ButtonLink>
        }
        demo={<HeroSplashAppDemo />}
      />

      <MarketingScenarioModelSection />

      <Section
        id="early-access"
        headline="Get early access"
        subheadline={<p>Tell us about your team, and we&apos;ll email you the moment access opens.</p>}
        cta={
          <ButtonLink href={primaryCtaHref()} size="lg" className="self-start">
            {primaryCtaLabel()}
          </ButtonLink>
        }
      />
    </MinimalMarketingLayout>
  )
}
